// extracted by mini-css-extract-plugin
export default {"search":"BannerItems_search__RCH2j","image":"BannerItems_image__gortu"};